import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from "../../shared";

@Injectable({ providedIn: "root" })
export class GendocBatchPrintingService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX;
    this.httpClient = http;
  }

  getDoc(
    serverDoc: any,
    printableFormatHdrGuid: any,
    dtoObject,
    visa: ApiVisa
  ): Observable<Blob> {
  
    this.apiUrl = visa.api_domain_url + this.endpoint_path + serverDoc + "/batch-print-jasper-pdf?printableFormatHdrGuid=" + printableFormatHdrGuid
  

    return this.httpClient.post<Blob>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeaderBlob(visa)
    );
  }

  getCustomDoc(
    serverDoc: any,
    printableFormatHdrGuid: any,
    dtoObject,
    visa: ApiVisa
  ): Observable<Blob> {
  
    this.apiUrl = visa.api_domain_url + this.endpoint_path + serverDoc + "/custom/batch-print-jasper-pdf?printableFormatHdrGuid=" + printableFormatHdrGuid
  

    return this.httpClient.post<Blob>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeaderBlob(visa)
    );
  }
}
